export const en = {
  employeeOpportunityEventTypeModal: {
    title: 'Select your event type',
    description: "Choose what kind of event you'd like to organize",
    continue: 'Continue',
    singleEvent: {
      label: 'Single Event',
      description: 'Single volunteering activities with a specific start date and end time.',
    },
    ongoingEvent: {
      label: 'Community Action',
      description: 'Flexible campaigns like fundraisers and walkathons that volunteers can join over time.',
    },
  },
}
